var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHugeiconsBodyPartMuscle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 53,
    viewBox: "0 0 54 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.07317 44.8344C7.56582 48.4 18.4108 51.1974 23.5352 44.5253C29.0769 47.1747 38.2151 46.3534 45.6578 42.2026C46.691 41.6286 47.6691 40.9 48.2697 39.8755C49.6231 37.5683 49.654 34.367 47.1856 29.6444C43.068 19.3691 35.6651 10.3478 32.6756 6.72034C32.0619 6.16175 28.1474 5.36693 25.7585 4.6008C24.7031 4.27625 22.7403 4.05988 20.3934 7.15528C19.2784 8.62129 14.2203 12.2267 20.6363 14.6487C21.632 14.9026 22.3628 15.3685 26.8999 14.5405C27.4894 14.439 28.9643 14.5405 30.0042 16.3642L32.1767 19.4706C32.3798 19.7584 32.5081 20.0923 32.5498 20.4421C32.9295 23.7517 32.9163 27.8936 34.7621 29.9932C31.9139 27.9311 24.4647 25.4848 18.8523 32.4484M5.03784 28.5736C7.56435 26.3217 10.7854 25.0021 14.1656 24.8342C17.5459 24.6664 20.8818 25.6602 23.6191 27.6507",
    stroke: "white",
    strokeWidth: 3.31177,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHugeiconsBodyPartMuscle);
export default __webpack_public_path__ + "static/media/hugeicons_body-part-muscle.8ae026897ccd8872c564830e474fdc51.svg";
export { ForwardRef as ReactComponent };